<template>
  <div id="side-menu">
    <div class="row logo-row">
      <div class="col-9" v-if="loggedInUser">
        <div class="logo text-left" @click="goToHome">
          <img :src="logoURL" alt />
        </div>
      </div>
      <div
        :class="{
          'col-3 text-right notification-wrapper': true,
          'has-notification': hasNotification,
        }"
      >
        <audio
          autoplay
          src="/static/sounds/all-eyes-on-me.mp3"
          v-if="hasNotification"
        />
        <font-awesome-icon
          v-popover:notifications
          :icon="'bell'"
          class="notification-button"
          @click="showNotifications"
        />
        <span class="badge"></span>
      </div>
      <popover name="notifications" :width="450">
        <notifications />
      </popover>
    </div>
    <div class="row" v-intro="$t('intro.profile')">
      <div class="col-12 profile-image-container">
        <div class="profile-image-wrapper">
          <profile-image :user="loggedInUser" class="profile-image" />
        </div>
        <div class="user-name">
          <router-link
            class="user-name-link"
            :to="`/users/${loggedInUser._id}`"
            >{{ loggedInUser.userName }}</router-link
          >
          <div class="available-balance">
            {{
              $t('sidemenu.availableBalance', {
                credits: loggedInUser.availableBalance,
              })
            }}
          </div>
        </div>
      </div>
      <div class="col-12 profile-info-container">
        <div
          class="row no-gutters"
          v-intro="$t('intro.progress', { creditAmount: 20 })"
        >
          <div class="col-12">
            <div class="row no-gutters">
              <div class="col-12">
                <div class="feedback-fuel">
                  {{ $t('sidemenu.feedbackFuel') }}
                </div>
                <div class="sub-balance-ratio">{{ subBalanceRatio }}</div>
                <progress-bar :percent="remainingCreditPercent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <base-button
          @click="showFeedbackModal"
          :text="$t('sidemenu.feedbackButton.text')"
          class="feedback-button"
        />
      </div>
      <div class="col-12">
        <span class="exchange-button" @click="showExchangeModal">{{
          $t('sidemenu.exchangeButton.text')
        }}</span>
      </div>
    </div>
    <div class="row menu-row">
      <div class="col-12 menu-container">
        <div
          v-for="(link, index) in availableLinks"
          :key="index"
          :class="{ row: true, active: isActive(index) }"
        >
          <div class="col-12">
            <router-link :to="link.uri">{{
              $t(`sidemenu.links.${link.key}`)
            }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="row logout-row">
      <div class="col-12">
        <a target="_blank" href="mailto:admin@motivac.io">{{
          $t('sidemenu.feedback')
        }}</a>
      </div>
      <div class="col-12">
        <font-awesome-icon
          :icon="'power-off'"
          class="logout-button"
          @click="logOutClicked"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import ProfileImage from '@/components/shared/users/UserImage';
import UserRank from '@/components/shared/users/UserRank';
import ProgressBar from '@/components/shared/elements/ProgressBar';
import BaseButton from '@/components/shared/elements/BaseButton';
import ExchangeModal from '@/components/shared/modals/ExchangeModal';
import Notifications from '@/components/shared/notifications/Notifications';
import FeedbackModal from '@/components/shared/modals/FeedbackModal';

export default {
  name: 'SideMenu',
  components: {
    ProfileImage,
    ProgressBar,
    BaseButton,
    Notifications,
    UserRank,
  },
  data() {
    return {
      isExchangeEnable: false,
      links: [
        {
          key: 'leaderboard',
          uri: '/',
        },
        {
          key: 'transactions',
          uri: '/transactions',
        },
        {
          key: 'history',
          uri: '/history',
        },
        {
          key: 'team',
          uri: '/team',
          admin: true,
        },
        {
          key: 'profile',
          uri: '/profile',
        },
      ],
    };
  },
  props: {},
  created() {
    this.getExchangeTypes().then((exchangeTypes) => {
      this.isExchangeEnable = exchangeTypes.length > 0;
    });
  },
  mounted() {},
  computed: {
    ...mapGetters({
      loggedInUser: 'users/loggedInUserProfile',
    }),
    availableLinks() {
      if (this.loggedInUser.role === 1) {
        return this.links;
      }
      return this.links.filter((x) => !x.admin);
    },
    remainingCreditPercent() {
      // TODO: calculate from subBalance.outcome / company.monthlyCredit * 100
      return (this.loggedInUser.subBalance.outcome / 20) * 100;
    },
    subBalanceRatio() {
      // TODO:
      return `${this.loggedInUser.subBalance.outcome}/20`;
    },
    hasNotification() {
      return this.loggedInUser.hasUnreadNotifications;
    },
    logoURL() {
      return (
        this.loggedInUser.company.companyLogoURL || '/static/images/logo.svg'
      );
    },
    companyName() {
      return this.loggedInUser.company.name;
    },
  },
  methods: {
    ...mapActions({
      fetchLoggedInProfile: 'users/fetchLoggedInProfile',
      logOut: 'users/logOut',
      getExchangeTypes: 'exchanges/getExchangeTypes',
    }),
    isActive(index) {
      return this.$route.path === this.links[index].uri;
    },
    logOutClicked() {
      this.logOut().then(() => {
        this.$router.push({ name: 'AuthenticateScreen' });
      });
    },
    showExchangeModal() {
      this.$eventBus.showModal({
        bind: {
          is: ExchangeModal,
        },
      });
    },
    showNotifications() {
      setTimeout(() => {
        this.fetchLoggedInProfile();
      }, 1000);
    },
    goToHome() {
      window.location.href = '/';
    },
    exchangeFakeDoor() {
      this.$gtag.event('exchange', {});
    },
    showFeedbackModal() {
      this.$eventBus.showModal({
        bind: {
          is: FeedbackModal,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#side-menu {
  padding: 20px;
  height: 100%;
  position: absolute;
  background-color: #eee;
  z-index: 1;
  display: flex;
  flex-direction: column;
  width: 18%;
  .logo-row {
    margin-bottom: 20px;
  }
  .logo {
    height: 50px;
    cursor: pointer;
    margin-left: 15px;
  }
  .profile-image-container {
    margin-left: 30px;
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 0;
    .profile-image-wrapper {
      position: relative;
      .profile-image {
        height: 60px;
        width: 60px;
      }
      .user-rank {
        max-height: 22px;
        position: absolute;
        bottom: 1%;
        left: 1%;
        border-radius: 11px;
        background-color: #eee;
        padding: 6px;
      }
    }
  }
  .user-name {
    font-size: 18px;
    text-align: left;
    margin: 0 20px;
    line-height: 18px;
    // font-weight: bold;
  }
  .available-balance {
    color: $primary-color;
    opacity: 0.44;
    font-size: 14px;
    font-weight: 100;
    margin-right: 15px;
  }
  .profile-info-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 10px 0;
    .row {
      margin: 2px 0;
      .feedback-fuel,
      .sub-balance-ratio {
        font-size: 12px;
        display: inline-block;
        width: 48%;
        font-weight: bold;
      }
      .feedback-fuel {
        text-align: left;
      }
      .sub-balance-ratio {
        text-align: right;
      }
      .balance {
        margin-top: 15px;
      }
    }
  }
  .menu-row {
    flex: 2;
    .active {
      a {
        color: $primary-color;
      }
    }
    a {
      color: $base-font-color;
    }
    .menu-container {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .row {
        min-height: 40px;
        &:hover,
        &.active,
        a:hover {
          color: $primary-hover-color;
          cursor: pointer;
          //font-weight: bold;
          text-decoration: unset;
        }
      }
    }
  }
  .logout-row {
    .logout-button {
      opacity: 0.6;
      cursor: pointer;
      &:hover {
        color: $secondary-color;
      }
    }
  }
  .feedback-button {
    margin: 30px 15px;
    &.disabled {
      >>> .base-button {
        background-color: #ccc;
      }
    }
  }
  .exchange-button {
    cursor: pointer;
    color: $primary-color;
    &:hover {
      color: $primary-hover-color;
    }
  }
  .logo {
    font-size: 120%;
    display: flex;
    align-items: center;
    img {
      height: 50%;
      margin-right: 5px;
      //transform: rotate(-90deg);
    }
  }
  .company-name {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .notification-wrapper {
    display: flex;
    align-items: center;
    justify-content: end;
    flex-direction: row-reverse;
    position: relative;
    .notification-button {
      color: $base-font-color;
      opacity: 0.4;
      position: relative;
      cursor: pointer;
    }
    .badge {
      width: 8px;
      height: 8px;
      display: block;
      position: absolute;
      background-color: $secondary-color;
      top: calc(50% - 10px);
      right: 12px;
      border-radius: 5px;
      border: 1px solid #eee;
      visibility: hidden;
    }
    &.has-notification {
      .badge {
        visibility: visible;
      }
    }
  }
}
</style>
